import React from 'react';
import './DeviceWrapper.scss';
import PropTypes from 'prop-types';
import previewFrame from './img/iPhoneX.png';

/** A wrapper for previewing content in a device frame.
 * Requires a node for the content.
 */

function DeviceWrapper(props) {
  const { children, device } = props;
  return (
    <div className="device-wrapper">
      {device === 'iPhoneX' && (
        <img
          alt=""
          className="frame"
          height="768"
          src={previewFrame}
          width="1409"
        />
      )}
      <div className="preview-container">{children}</div>
    </div>
  );
}

DeviceWrapper.propTypes = {
  /** Preview contents, see <StoryPreview /> */
  children: PropTypes.node.isRequired,
  /** Device, currently only supports iPhone */
  device: PropTypes.oneOf(['iPhoneX']),
};

DeviceWrapper.defaultProps = {
  device: 'iPhoneX',
};

export default DeviceWrapper;
